import React from 'react';

import { Box, Text, Heading, SimpleGrid } from '@chakra-ui/react';

import { quotes } from '@utils/data';

import QuotesCard from '../cards/QuotesCard';

export default function Quotes() {
    return (
        <Box
            bg="#030912"
            py={{ base: 10, md: 20 }}
            px={{ base: 4, sm: 6, md: 10, lg: 20 }}
            mx={{ base: 0, md: -10, lg: -20 }}
            mb={{ base: 10, md: 20 }}
        >
            <Heading
                fontSize={{ base: '24px', sm: '28px', md: '36px', lg: '44px' }}
                fontWeight="semibold"
                color="white"
                mb={2}
                lineHeight={{ base: '32px', sm: '38px', md: '60px', lg: '80px', xl: '140px' }}
                textAlign="center"
            >
                The Power of Mentorship:{' '}
                <Text as="span" color="#4C50EA">
                    Words of Wisdom
                </Text>
            </Heading>

            <SimpleGrid
                columns={{ base: 1, sm: 2, md: 2, lg: 4 }}
                justifyItems="center"
                spacing={6}
                px={10}
            >
                {quotes.map((quoteItem, index) => (
                    <QuotesCard
                        key={index}
                        quote={quoteItem.quote}
                        rating={quoteItem.rating}
                        name={quoteItem.name}
                    />
                ))}
            </SimpleGrid>
        </Box>
    );
}
